import React from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import * as compensationEventCrud from '../../../../crud/compensationEvent.crud';
import moment from 'moment';
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import { notificationAggregateListTagsFilter, notificationUniqueTagsFilter, notificationUniqueTagsFilterV3 } from "../../../../store/helpers/FilterHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import { getCompensationPathWithType, getCENBadgeVariantByStatus } from './ListAll';
import BaseListPage from '../../_CustomComponents/BaseListPage';

class CompensationListImplemented extends BaseListPage {
    constructor(props) {
        super(props);

        this.maxReferenceIDPrefix = 'CEN-';
        if (this.props.notificationAbbreviation_SUP && this.maxReferenceIDPrefix.length < this.props.notificationAbbreviation_SUP.length) {
            this.maxReferenceIDPrefix = this.props.notificationAbbreviation_SUP;
        }
        if (this.props.notificationAbbreviation_PM && this.maxReferenceIDPrefix.length < this.props.notificationAbbreviation_PM.length) {
            this.maxReferenceIDPrefix = this.props.notificationAbbreviation_PM;
        }
        if (this.props.notificationAbbreviation_CLIENT && this.maxReferenceIDPrefix.length < this.props.notificationAbbreviation_CLIENT.length) {
            this.maxReferenceIDPrefix = this.props.notificationAbbreviation_CLIENT;
        }

        this.compensationStatuses = props.placeholders
            .find(ph => ph.replacementKey === 'CompensationStatuses')
            .values.filter(item => item.isActive === true);

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }
        this.proposedCenWorkflowsExist = !!(this.props.workflowsQA['84'] || this.props.workflowsQA['6']);
        this.state = {
            notifications: null,
            tags: null
        }
    }
    componentDidMount() {
        super.componentDidMount();
        this.fetchCompensationEvents2();
    }
    fetchCompensations = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            //const states = ['AM', 'QA', 'DA'];
            const { data: responseObj } = await compensationEventCrud.getCompansationEventsReduced(companyid, projectid, contractid, '', this.props.accessibleWfIds);
            let listData = notificationAggregateListTagsFilter(responseObj.aggregatelist);
            listData = listData.filter(ntf => !!ntf.assessmentdate);
            let tagFilters = notificationUniqueTagsFilter(responseObj.uniquetags);
            this.setState({ notifications: listData, tags: tagFilters });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }
    fetchCompensationEvents2 = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const statesImplemented = ['AM', 'QA', 'DA', 'VOI'];
            let { data: responseObj } = await compensationEventCrud.getCompansationEventsReduced2(
                companyid,
                projectid,
                contractid,
                '',
                false,
                this.props.accessibleWfIds);
            responseObj = responseObj.filter(ntf => statesImplemented.includes(ntf.status));
            let notifications = CustomFieldHelper.MapDataListCustomFieldsToObjectPropertiesV2(responseObj);
            let tagFilters = notificationUniqueTagsFilterV3(this.props.communicationTags);
            this.setState({ notifications, tags: tagFilters });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }
    formatCurrency = () => {

        return this.props.contract.currency
    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        //const { workflowItem } = this.props;
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        const { workflowItem } = this.props;
        const compensationPath = getCompensationPathWithType(rowData.compensationsource);
        return `${skipHostUrl ? '' : process.env.PUBLIC_URL}${workflowItem.paths.groupFullPath}${compensationPath}/${rowData.compensationeventid}`;
    }


    renderQuoteReceived = (cellInfo) => {
        if (cellInfo.data.officereceiveddate) {
            let badgeVariant = 'secondary';
            const quoteRequiredDate = new Date(cellInfo.data.requiredate);
            const quoteReceiveDate = new Date(cellInfo.data.officereceiveddate);
            if (quoteRequiredDate < quoteReceiveDate) {
                badgeVariant = 'danger';
            }
            else {
                badgeVariant = 'success';
            }
            return (<Badge variant={badgeVariant}>{moment(cellInfo.data.officereceiveddate).format('L')}</Badge>);
        }
    }
    pmResponseReceived = (cellInfo) => {
        if (cellInfo.data.projectmanagerresponsedate) {
            let badgeVariant = 'secondary';
            const pmResponseRequiredDate = new Date(cellInfo.data.projectmanagersigneddate);
            const pmResponseReceiveDate = new Date(cellInfo.data.projectmanagerresponsedate);
            if (pmResponseRequiredDate < pmResponseReceiveDate) {
                badgeVariant = 'danger';
            }
            else {
                badgeVariant = 'success';
            }
            return (<Badge variant={badgeVariant}>{moment(pmResponseReceiveDate).format('L')}</Badge>);
        }
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = getCENBadgeVariantByStatus(cellInfo.data.status);
        let status = this.renderStatusDisplay(cellInfo.data);
        return (<Badge variant={badgeVariant}>{status}</Badge>);
    }
    renderStatusDisplay = (rowData) => {
        const status = this.compensationStatuses.find(x => x.field === rowData.status);
        if (status) {
            return status.display;
        } else {
            return rowData.status;
        }
    }
    sortIdColumn = (rowData) => {
        return rowData.sequencenumber;
    }
    renderProposalIdColumn = (rowData) => {
        if (rowData.compensationsource === 'PRO' || rowData.compensationsource === 'SupplierProp') {
            return rowData.referenceid;
        }
        else {
            return null;
        }

    }
    render() {
        if (!this.state.notifications) {
            return (<PortletSpinner />);
        }
        const columns = [
            { resource: "GENERAL.FORMS.FIELD.CEN_ID", dataField: "referenceid_cen", dataType: 'string', calculateSortValue: this.sortIdColumn },
        ];
        if (this.proposedCenWorkflowsExist) {
            columns.push(
                { resource: "CONTRACT.WF.COMPENSATION.FIELD.PROPOSAL_ID", dataField: "typesequence", visible: true, dataType: 'string', calculateCellValue: this.renderProposalIdColumn },
            );
        }
        columns.push(
            { caption: "Implemented Reference", dataField: "implementedreferenceid", visible: true, dataType: 'string' },
            { resource: "GENERAL.FORMS.FIELD.SUBJECT", dataField: 'compensationnumber' },
            { resource: "GENERAL.FORMS.FIELD.CLAUSE", dataField: "compensationtype" },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_BY", dataField: "communicatedby" },
            { resource: "CONTRACT.WF.COMPENSATION.FIELD.QUOTE_REQUIRED", dataField: "requiredate", dataType: 'date', visible: false },
            { resource: "CONTRACT.WF.COMPENSATION.FIELD.QUOTE_RECEIVED", dataField: "officereceiveddate", dataType: 'date', cellRender: this.renderQuoteReceived, visible: false },
            { caption: this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.RESPONSE_REQUIRED' }), dataField: "projectmanagersigneddate", dataType: 'date' },
            { caption: this.props.intl.formatMessage({ id: 'CONTRACT.WF.COMPENSATION.FIELD.RESPONSE_RECEIVED' }), dataField: "projectmanagerresponsedate", dataType: 'date', cellRender: this.pmResponseReceived },
            { resource: "GENERAL.FORMS.REPLING_PARTY", dataField: "replyingparty", lookup: { dataSource: this.props.contractTemplate.parties.options, valueExpr: 'id', displayExpr: 'display' }, visible: false },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.renderStatusDisplay, visible: false },
            { resource: "CONTRACT.WF.COMPENSATION.FIELD.IMPLEMENTED", dataField: "assessmentdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.AMOUNT", dataField: "assessmentamount", dataType: 'currency', currencyCode: this.props.contract.currency },
            { resource: "GENERAL.FORMS.FIELD.DAYS", dataField: "alternativequotation", dataType: 'string' },
            { resource: "GENERAL.FORMS.FIELD.DETAILS", dataField: "description", isHtml: true },
            { resource: "CONTRACT.WF.COMPENSATION.FIELD.ASSUMPTIONS", dataField: "assumption", isHtml: true },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "GENERAL.FORMS.FIELD.CURRENCY", dataField: "currency", visible: false, calculateCellValue: this.formatCurrency },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { resource: "CONTRACT.WF.COMPENSATION.FIELD.ORIGINALQUOTEDAMOUNT", dataField: "originalquotedamount", dataType: 'currency', currencyCode: this.props.contract.currency, visible: false },
            { resource: "CONTRACT.WF.COMPENSATION.FIELD.MAXIMUMQUOTEDAMOUNT", dataField: "maximumquotedamount", dataType: 'currency', currencyCode: this.props.contract.currency, visible: false },
            { resource: "CONTRACT.WF.COMPENSATION.FIELD.LATESTQUOTEDAMOUNT", dataField: "latestquotedamount", dataType: 'currency', currencyCode: this.props.contract.currency, visible: false }
        );
        if (this.props.globalResources.CEN_DEEMED_ACCEPTANCE_STARTS !== 'OFF') {
            columns.push(
                { resource: "CONTRACT.WF.COMPENSATION.FIELD.CEN_DEEM_DATE", dataField: "cendeemedacceptancedate", dataType: 'date' }
            );
        }
        if (this.props.globalResources.QUOTE_DEEMED_ACCEPTANCE_STARTS !== 'OFF') {
            columns.push(
                { resource: "CONTRACT.WF.COMPENSATION.FIELD.QUOTE_DEEM_DATE", dataField: "quotedeemedacceptancedate", dataType: 'date' }
            );
        }
        if (this.notificationsTagsEnabled && this.state.tags != null) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.OtherFilter } }
            )
        }
        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));

        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="4"
                        title={this.props.workflowItem.pageTitle}
                        referenceIDPrefix={this.maxReferenceIDPrefix}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.notifications}
                        keyExpr="compensationeventid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                    />
                </PortletBody>
            </Portlet>
        );
    }
}



export default withListPageProps(CompensationListImplemented);
